import { render, staticRenderFns } from "./ServicesCategoriesPage.vue?vue&type=template&id=2a274547"
import script from "./ServicesCategoriesPage.vue?vue&type=script&lang=js"
export * from "./ServicesCategoriesPage.vue?vue&type=script&lang=js"
import style0 from "./ServicesCategoriesPage.vue?vue&type=style&index=0&id=2a274547&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports